// Define the interface for the option model
export interface Option {
  viewValue: string;
  value: string;
}

// Define the array of options
export const OPTIONS: Option[] = [
  { viewValue: 'Common Adm', value: 'common_adm' },
];
